import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

/** Props Interface */
interface UseWikiPageProps {
	pageId: Nullable<string>;
	spaceId: Nullable<string>;
}

export function useWikiPage({ pageId, spaceId }: UseWikiPageProps) {
	/** Query */
	const query = useQuery({
		queryKey: ["wiki-page", pageId ?? "--"],
		queryFn: async () => {
			if (!pageId || !spaceId) throw new Error("No current page or space ID");
			const response = await client.wiki.spaces[":spaceId"].pages[":pageId"].$get({
				param: { spaceId, pageId },
			});
			const data = await responseHandler(response);
			return data.wikiPage;
		},
		enabled: !!pageId && !!spaceId,
	});

	/** Return */
	return { ...query, wikiPage: query.data };
}
